module.exports = {"id":"203668","name":"Alfredo Donnarumma","rating":"73","photo":"./data/images/photos/1/203668.png","club":{"name":"Empoli","logo":"./data/images/clubs/Empoli.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlfredoDonnarumma0.json
// module id = 283
// module chunks = 0